import { memo } from "react";
import { EmptyState, Heading, Icons, Paragraph } from "@ir/ui";

interface ApprovalsEmptyStateProps {
  isLoading: boolean;
  error: Error | null;
  hasApprovals: boolean;
  isRefreshing: boolean;
}

const ApprovalsEmptyState = memo(({ isLoading, error, hasApprovals, isRefreshing }: ApprovalsEmptyStateProps) => {
  if (isLoading) {
    return null;
  }

  if (error) {
    return (
      <EmptyState
        className="bg-white border-1 border-color-grey-25 px-4 py-5 mt-4"
        icon={Icons.InfoOctagon}
        title={
          <Heading level={6} className="text-grey-700 font-bold mt-3">
            An error occurred while fetching approvals.
          </Heading>
        }
        description={<Paragraph className="text-grey-500 font-regular mb-0">Please try again.</Paragraph>}
      />
    );
  }

  if (!hasApprovals && !isRefreshing) {
    return (
      <EmptyState
        className="bg-white border-1 border-color-grey-25 px-4 py-5 mt-4"
        icon={Icons.CheckDone}
        title={
          <Heading level={6} className="text-grey-700 font-bold mt-3">
            No Approval(s) Found
          </Heading>
        }
        description={
          <Paragraph className="text-grey-500 font-regular mb-0">
            This is where you can view all your deductions that are awaiting approval.
          </Paragraph>
        }
      />
    );
  }

  return null;
});

ApprovalsEmptyState.displayName = "ApprovalsEmptyState";

const ApprovalCommentsEmptyState = memo(() => {
  return (
    <EmptyState
      className="px-4 py-5 h-100"
      icon={Icons.MessageChatCircle}
      title={
        <Heading level={6} className="text-grey-700 font-bold mt-3">
          No Comment(s) Found
        </Heading>
      }
      description={<Paragraph className="text-grey-500 font-regular mb-0">This is where you can view all previous comments</Paragraph>}
    />
  );
});

ApprovalCommentsEmptyState.displayName = "ApprovalCommentsEmptyState";

export { ApprovalsEmptyState, ApprovalCommentsEmptyState };
